import { createTheme, responsiveFontSizes } from '@material-ui/core/styles'
import {
  primaryColor,
  secondaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
} from "./material-kit-pro-react"

const baseTheme = {
  components: {
    // Name of the component
    MuiTooltip: {
      styleOverrides: {
        // Name of the slot
        tooltip: {
          // Some CSS
          fontSize: '1rem',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e5e5e5'
        },
        head: {
          borderBottom: '1px solid #e5e5e5'
        }
      }
    },
  },
  status: {
    info: "#00acc1",
  },
  palette: {
    primary: { main: "#00acc1", dark: "#1d405d" },
    secondary: { main: "#4caf50" },
    info: { main: "#00acc1" },
    success: { main: "#4caf50" },
    danger: { main: "#f44336" },
    warning: { main: "#ff9800" },
  }
}
const defaultTheme = createTheme(baseTheme);

let theme = {
  ...defaultTheme,
}
theme = responsiveFontSizes(theme);
export default theme;